/*
  OFFE - TEST (Oct 27, 2026): product count in the homepage
  New / Best sellers / Back in stock row. The slider shows 5.5 cards from
  1200px up (Rachel, later Oct 27; before that 3.5 from 1200px and 4 from
  1360px; the section settings say 4 and 6). Waits for the theme to build
  each tab's slider, then changes it. Goes with
  assets/custom-figma-scale-test.css; delete both lines in
  layout/theme.liquid to undo.
*/
(function () {
  function patch(el) {
    var sw = el.swiper;
    if (!sw) return false;
    if (sw.__offeScaleTest) return true;
    sw.__offeScaleTest = true;
    var bp = sw.params.breakpoints || (sw.params.breakpoints = {});
    bp[1200] = Object.assign({}, bp[1200], { slidesPerView: 5.5 });
    bp[1360] = Object.assign({}, bp[1360], { slidesPerView: 5.5 });
    sw.currentBreakpoint = null;
    sw.setBreakpoint();
    sw.update();
    return true;
  }
  function run() {
    if (!document.body.classList.contains('template-index')) return;
    var tries = 0;
    (function tick() {
      var els = document.querySelectorAll('.popular-products-section .js-popular-products-slider');
      var done = els.length > 0;
      els.forEach(function (el) { if (!patch(el)) done = false; });
      if (!done && ++tries < 60) setTimeout(tick, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
